export enum AppNotificationTag {
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  NEW_FEATURE = 'NEW_FEATURE',
  BUG_FIX = 'BUG_FIX',
}

export enum AppNotificationPlatform {
  WEB = 'WEB',
  MOBILE = 'MOBILE',
}

export enum AppNotificationAudience {
  STAFF = 'STAFF',
  PROMOTER = 'PROMOTER',
  PARTNER = 'PARTNER',
}

export enum AppNotificationPlatformName {
  WEB = 'Web',
  MOBILE = 'Mobile',
}

export enum AppNotificationAudienceName {
  STAFF = 'Staff',
  PROMOTER = 'Promoter',
  PARTNER = 'Partner',
}

export enum AppNotificationTagName {
  ANNOUNCEMENT = 'Announcement',
  NEW_FEATURE = 'New Feature',
  BUG_FIX = 'Bug Fix',
}
